module.exports = __webpack_public_path__ + "static/media/is_garage.240da197.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_garage.svg
// module id = 1525
// module chunks = 0